import i18next from 'i18next';
import { toast } from 'sonner';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class LessonLearnedIntegration {
    constructor(service) {
        this.service = service;
    }

    async fetchAll(params = {}) {
        try {
            const response = await this.service.getAll(params);
            return { success: true, data: response.data || [], pagination: response.pagination || {} };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, data: [] };
        }
    }

    async create(data) {
        try {
            const response = await this.service.create(data);
            toast.success(i18next.t('integrationToasts:lessonLearnedCreatedSuccessfully', { defaultValue: 'Lesson learned created successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }

    async update(id, data) {
        try {
            const response = await this.service.update(id, data);
            toast.success(i18next.t('integrationToasts:lessonLearnedUpdatedSuccessfully', { defaultValue: 'Lesson learned updated successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }

    async delete(id) {
        try {
            const response = await this.service.delete(id);
            toast.success(i18next.t('integrationToasts:lessonLearnedDeletedSuccessfully', { defaultValue: 'Lesson learned deleted successfully' }));
            return { success: true };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }

    async batchDelete(ids) {
        try {
            const response = await this.service.batchDelete(ids);
            toast.success(i18next.t('integrationToasts:lessonsLearnedDeletedSuccessfully', { defaultValue: 'Lessons learned deleted successfully' }));
            return { success: true };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false };
        }
    }
}
